import { login,switchLoginUser, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken,getAdminToken,setAdminToken,removeAdminToken } from '@/utils/auth'
import { noticeMessageCount } from '@/api/api'

const user = {
  state: {
    messages: 0,
    token: getToken(),
    adminToken: getAdminToken(),
    name: '',
    avatar: '',
    defaultPassword:'',
    user:{},
    roles: [],
    permissions: []
  },

  mutations: {
    SET_MESSAGE_COUNT:(state,count)=>{
      state.messages = count 
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ADMIN_TOKEN: (state, adminToken) => {
      state.adminToken = adminToken
    },
    SET_USER:(state,user)=>{
      state.user = user
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_PASSWORD_DEFAULT: (state,defaultPassword)=>{
      state.defaultPassword = defaultPassword
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.imageCode
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          setToken(res.data.data.token)
          commit('SET_TOKEN', res.data.data.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    SwitchLogin({ commit },userInfo){
      const userId = userInfo.userId
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        switchLoginUser(userId,password).then(res => {
          //原来admin的token
          setAdminToken(getToken());
          commit('SET_ADMIN_TOKEN', getToken())
          setToken(res.data.data.token)
          //切换后的token
          commit('SET_TOKEN', res.data.data.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    //获取用户未读消息
    UnreadMessage({ commit }){
      return new Promise((resolve, reject) => {
        noticeMessageCount().then(res => {
          commit('SET_MESSAGE_COUNT', res.data.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          let data = res.data.data;
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
            commit('SET_PERMISSIONS', data.permissions)
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT'])
          }
          const user = {
            "userType" : data.userType,
            "roleType": data.roleType,
            "username" : data.username,
            "level" : data.level,
            "userId" : data.userId,
            "userCommissionType" : data.userCommissionType,
            "showTimeCommission": data.showTimeCommission
          };
          commit('SET_PASSWORD_DEFAULT',data.isDefault == '0');
          commit('SET_USER', user)
          commit('SET_NAME', data.username)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          removeAdminToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        removeAdminToken()
        resolve()
      })
    }
  }
}

export default user
